import React, { Fragment, useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Grid, Button, Card } from "@material-ui/core";

import DisputeContext from "../../../../context/paypal/disputes/DisputeContext";

import SpinnerSmall from "../../../layout/SpinnerSmall";

import ConfirmationModal from "./ConfirmationModal";

const FunctionEscalate = ({
  state,
  setState,
  dispute,
  selectedFunction,
  handleClose,
  setReturnedMsg,
}) => {
  const disputeContext = useContext(DisputeContext);
  const { escalateDispute, loading } = disputeContext;

  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmDisplay, setConfirmDisplay] = useState("");

  const useStyles = makeStyles((theme) => ({
    modalBody: {
      padding: theme.spacing(2),
    },
    inputWidth: {
      width: "100%",
    },
  }));

  const classes = useStyles();

  //Filter Input Value
  const onInputChange = (e) => {
    e.preventDefault();
    e.persist();

    if (e.target.id === "note_value") {
      const value = e.target.value;
      let errors = state.escalate.errors;
      let escalate = state.escalate;
      if (value.length > 2000) {
        errors.note_value = "Maximum 2000 characters";
      } else {
        errors.note_value = "";
      }
      escalate.note_value = value;
      setState((state) => ({
        ...state,
        escalate: escalate,
      }));
    }
  };

  const [isLoading, setIsLoading] = useState();
  const [okClick, setOkCLick] = useState();

  useEffect(() => {
    if (isLoading === true) {
      if (loading === false) {
        handleClose();
        setIsLoading(false);
      }
    }
    //eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    if (okClick === "escalate") {
      escalateDispute(dispute.dispute_id, state.escalate.note_value);
      setReturnedMsg("");
      setIsLoading(true);
      setOkCLick("");
    }
    //eslint-disable-next-line
  }, [okClick]);

  const onSubmit = (e) => {
    e.preventDefault();
    setConfirmModal(true);
    setConfirmDisplay([
      {
        label: "Note",
        value: state.escalate.note_value,
      },
    ]);
  };

  return (
    <Fragment>
      {" "}
      {selectedFunction === "escalate" ? (
        <Grid container direction="column" className={classes.modalBody}>
          <Card className={classes.modalBody}>
            <Grid container direction="column" spacing={4}>
              <Grid item>
                <TextField
                  type="text"
                  variant="outlined"
                  id="note_value"
                  name="note_value"
                  size="small"
                  fullWidth
                  label="Note"
                  placeholder="Leave a note..."
                  multiline
                  rows={10}
                  maxRows={20}
                  value={state.escalate.note_value}
                  onInput={onInputChange}
                  helperText={
                    state.escalate.errors.note_value
                      ? state.escalate.errors.note_value
                      : "Only PayPal can view these notes."
                  }
                  error={state.escalate.errors.note_value ? true : false}
                  disabled={loading === false ? false : true}
                />{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={onSubmit}
                    disabled={
                      state.escalate.note_value.length > 0 &&
                      state.escalate.note_value.length <= 2000 &&
                      loading === false
                        ? false
                        : true
                    }
                  >
                    {loading ? (
                      <div className="d-flex mx-auto my-auto">
                        <SpinnerSmall />
                      </div>
                    ) : (
                      <Fragment> {"Submit"} </Fragment>
                    )}{" "}
                  </Button>{" "}
                </Grid>{" "}
                <ConfirmationModal
                  confirmModal={confirmModal}
                  setConfirmModal={setConfirmModal}
                  confirmDisplay={confirmDisplay}
                  setConfirmDisplay={setConfirmDisplay}
                  setOkCLick={setOkCLick}
                  selectedFunction={selectedFunction}
                />{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Card>{" "}
        </Grid>
      ) : null}{" "}
    </Fragment>
  );
};

export default FunctionEscalate;
